import { observer } from 'mobx-react-lite';

import { company } from '~/company/Company';
import { CompanyName } from '~/company/interface';

import { LayoutCD } from './LayoutCD';
import { LayoutLocalee } from './LayoutLocalee';

const getFooter = (companyName: CompanyName) => {
  switch (companyName) {
    case CompanyName.CityDrinks:
      return LayoutCD;
    default:
      return LayoutLocalee;
  }
};
export default observer(() => {
  const Content = getFooter(company.name);

  return <Content />;
});
